import client from "libs/HttpClient";

/**
 * Service class for handling Settings.
 */
class SettingsService {
  /**
   * Adds a new Settings based on the provided request.
   *
   * @param request - The request parameters for adding a Settings.
   * @returns A Promise that resolves to the Axios response for the add Settings request.
   */
  static addApiKeyData(request: any) {
    return client.put("admin/setting/api-key", request);
  }

  /**
   * Retrieves the details of a Api Key based on the provided parameters.
   *
   * @param params - The parameters for retrieving the API Key details.
   * @returns A Promise that resolves to the Axios response containing the API Key details.
   */
  static viewApiKey(request: any) {
    return client.get(`admin/setting/get-api-key`, request);
  }
}

export { SettingsService };
